var map = {
	"./5-Dragons-ultra-bottom.png": 21215,
	"./5-Dragons-ultra-top.png": 10152,
	"./5-dragons-ultra_logo.png": 1502,
	"./Casino-Wizard-bottom.png": 18362,
	"./Casino-Wizard-top.png": 36474,
	"./Coin-Combo-bottom.png": 52479,
	"./Coin-Combo-top.png": 21989,
	"./DFDC_Grand_logo.png": 82594,
	"./Double-Money-LInk-logo.png": 52840,
	"./Double-money-link-bottom.png": 75761,
	"./Double-money-link-top.png": 17535,
	"./Duo-Fu-Duo-Cai-bottom.png": 39105,
	"./Duo-Fu-Duo-Cai-top.png": 44144,
	"./Fudai-lian-lian-bottom.png": 31683,
	"./Fudai-lian-lian-top.png": 95505,
	"./Huff-N-More-Puff_logo.png": 17976,
	"./Huff-more-puff-bottom.png": 65196,
	"./Huff-more-puff-top.png": 13958,
	"./JEU-MAS-CCCC-Carte_logo.png": 14025,
	"./Slot4-bottom.png": 21965,
	"./Slot4-top.png": 72583,
	"./Slot5-bottom.png": 65946,
	"./Slot5-top.png": 56453,
	"./Slot6-bottom.png": 98256,
	"./Slot6-top.png": 71787,
	"./ani_logo_s.gif": 26438,
	"./baccarat_bg.png": 5529,
	"./baccarat_person.png": 96135,
	"./baccarat_title_bg.png": 83899,
	"./background.png": 10130,
	"./banner01.png": 85895,
	"./banner02.png": 20466,
	"./banner03.png": 94675,
	"./banner04.png": 43213,
	"./blackjack_bg.png": 68817,
	"./blackjack_person.png": 91331,
	"./coin_mouse_img.png": 95852,
	"./coin_mouse_logo.png": 76633,
	"./eye-icon.png": 49203,
	"./fudailianlian_logo.png": 93971,
	"./hamburger.png": 73971,
	"./header-logo.png": 73470,
	"./header_logo_bg.png": 14950,
	"./hurricane_horse_img.png": 43173,
	"./hurricane_horse_logo.png": 4211,
	"./locked-icon.png": 56785,
	"./logo.png": 82236,
	"./menu-bar.png": 27059,
	"./play-icon.png": 30166,
	"./racing_bg.png": 83417,
	"./racing_person.png": 67667,
	"./racing_title_bg.png": 2060,
	"./sicbo_bg.png": 88270,
	"./sicbo_dice.png": 22885,
	"./tian-phoenix_bottom.png": 76914,
	"./tian-phoenix_logo.png": 85372,
	"./tian-phoenix_top.png": 29307,
	"./view-button.png": 80226,
	"./watch-button.png": 14713,
	"./winnball_bg.png": 99264,
	"./winnball_chip.png": 3328,
	"./winnball_title_bg.png": 41489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79277;